import React, { createContext } from 'react';
import { SecondaryBudgetAxisSources } from 'routes/Support/components/ClientSupport/components/BudgetConfiguration/types';

export const SecondaryBudgetAxisSourceTableContext: React.Context<SecondaryBudgetAxisSources | null> =
    createContext<SecondaryBudgetAxisSources | null>(null);

/**
 * Select the secondary budget axis source table value in Context.
 * It is used to display the right axis name in several Budget views (related to "Operations").
 */
export const useSelectSecondaryBudgetAxisSourceTable = () => {
    return React.useContext(SecondaryBudgetAxisSourceTableContext);
};
